import styled, { css, keyframes } from "styled-components";

//MISC

export const Container = styled.div<{ width; height }>`
  float: "left";
  margin: 1em 0;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
`;
